var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterAltOff2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#4E3E91"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3097 9.184C24.432 9.02653 24.5076 8.83789 24.5278 8.63957C24.5481 8.44126 24.5123 8.24123 24.4245 8.06226C24.3367 7.88329 24.2004 7.73257 24.0311 7.62728C23.8619 7.52198 23.6664 7.46633 23.4671 7.46666H10.4857L18.9871 15.968L24.3097 9.184ZM25.0564 25.056L6.94439 6.944C6.74495 6.74455 6.47445 6.63251 6.19239 6.63251C5.91034 6.63251 5.63984 6.74455 5.44039 6.944C5.24095 7.14344 5.12891 7.41394 5.12891 7.696C5.12891 7.97805 5.24095 8.24855 5.44039 8.448L13.8671 17.0667V22.4C13.8671 23.5733 14.8271 24.5333 16.0004 24.5333C17.1737 24.5333 18.1337 23.5733 18.1337 22.4V21.152L23.5417 26.56C23.9577 26.976 24.6297 26.976 25.0457 26.56C25.4617 26.144 25.4724 25.472 25.0564 25.056Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterAltOff2);
export default __webpack_public_path__ + "static/media/filter-alt-off2.7f692b8135a69c442cb7744979e73d20.svg";
export { ForwardRef as ReactComponent };